export default "__VITE_ASSET__BlMSELqd__"